/* vue-kerlink version 3.0.3 */
import jump from 'jump.js';

//

var script = {
  data () {
    return {
      show: false
    }
  },

  mounted () {
    // Setup scrollspy to display return-to-top button
    window.addEventListener('scroll', this.checkPosition);
  },

  destroyed () {
    window.removeEventListener('scroll', this.checkPosition);
  },

  methods: {
    scrollToTop () {
      jump('body', {
        // Fixed navbar height: 60px
        offset: -60,
        duration: 500
      });
    },

    checkPosition () {
      const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

      // If page is scrolled more than 50px
      if (scrollPosition >= 250) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "a",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "btn-primary",
      attrs: { id: "return-to-top" },
      on: { click: _vm.scrollToTop }
    },
    [_c("i", { staticClass: "icon-angle-right" })]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-447fab64_0", { source: "#return-to-top[data-v-447fab64] {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  text-decoration: none;\n  background: #1b3563;\n  border-radius: 35px;\n  opacity: 0.7;\n  transition: all 0.3s ease;\n}\n#return-to-top i[data-v-447fab64] {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #fff;\n  transform: rotate(-90deg);\n}\n#return-to-top[data-v-447fab64]:hover {\n  cursor: pointer;\n  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);\n  opacity: 0.9;\n}\n\n/*# sourceMappingURL=ScrollToTop.vue.map */", map: {"version":3,"sources":["C:\\Users\\alg\\Workspace_Dashboard\\vue-kerlink\\src\\components\\ScrollToTop.vue","ScrollToTop.vue"],"names":[],"mappings":"AAmDA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;AClDA;ADoDA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AClDA;ADqDA;EACA,eAAA;EACA,+GAAA;EACA,YAAA;ACnDA;;AAEA,0CAA0C","file":"ScrollToTop.vue","sourcesContent":["<template>\n  <a v-show=\"show\" id=\"return-to-top\" class=\"btn-primary\" @click=\"scrollToTop\">\n    <i class=\"icon-angle-right\" />\n  </a>\n</template>\n\n<script>\nimport jump from 'jump.js'\n\nexport default {\n  data () {\n    return {\n      show: false\n    }\n  },\n\n  mounted () {\n    // Setup scrollspy to display return-to-top button\n    window.addEventListener('scroll', this.checkPosition)\n  },\n\n  destroyed () {\n    window.removeEventListener('scroll', this.checkPosition)\n  },\n\n  methods: {\n    scrollToTop () {\n      jump('body', {\n        // Fixed navbar height: 60px\n        offset: -60,\n        duration: 500\n      })\n    },\n\n    checkPosition () {\n      const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop\n\n      // If page is scrolled more than 50px\n      if (scrollPosition >= 250) {\n        this.show = true\n      } else {\n        this.show = false\n      }\n    }\n  }\n}\n</script>\n\n<style scoped lang=\"scss\">\n  @import \"../scss/variables\";\n\n  #return-to-top {\n    position: fixed;\n    right: 24px;\n    bottom: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    text-decoration: none;\n    background: $primary;\n    border-radius: 35px;\n    opacity: 0.7;\n    transition: all 0.3s ease;\n\n    i {\n      margin: 0;\n      font-size: 1.5rem;\n      color: $white;\n      transform: rotate(-90deg);\n    }\n\n    &:hover {\n      cursor: pointer;\n      box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);\n      opacity: 0.9;\n    }\n  }\n</style>\n","#return-to-top {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  text-decoration: none;\n  background: #1b3563;\n  border-radius: 35px;\n  opacity: 0.7;\n  transition: all 0.3s ease;\n}\n#return-to-top i {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #fff;\n  transform: rotate(-90deg);\n}\n#return-to-top:hover {\n  cursor: pointer;\n  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);\n  opacity: 0.9;\n}\n\n/*# sourceMappingURL=ScrollToTop.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-447fab64";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  

  
  var ScrollToTop = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    browser,
    undefined
  );

export default ScrollToTop;
